import { useRepositories } from '../../../contexts';
import { useAppQuery } from '../utils';
import { useLanguage } from '../../../locale';
export var useGetFamilyImpactApi = function (familyId, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    var familyRepo = useRepositories().familyRepo;
    var _a = useLanguage(), locale = _a[2];
    var queryKey = ['getFamilyImpact', familyId, locale];
    return useAppQuery(queryKey, function () {
        if (!familyId)
            throw new Error('Family ID is required');
        return familyRepo.getFamilyImpact(familyId);
    }, {
        enabled: !!familyId && isEnabled,
    });
};
